import Appointment from "./Appointment.tsx";
export default Appointment;
